// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formAdministration--wrapper {
  min-height: calc(100vh - 160px);
  padding-top: 40px;
}
.formAdministration--wrapper .breadCrumb__wrapper {
  padding: 0 40px 10px;
}
.formAdministration--content {
  width: calc(100% - 80px);
  margin: 10px auto 30px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #edf0f2;
  padding-left: 5px;
}
.formAdministration--heading {
  font-size: 20px;
  line-height: 1.4;
  padding: 22px 25px;
}
.formAdministration--table {
  width: 100%;
}
.formAdministration--table thead {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
  border-bottom: 1px solid #edf0f2;
}
.formAdministration--table th {
  font-size: 12px;
  line-height: 1.5;
  color: #989eac;
  font-weight: 500;
  padding: 18px 10px;
  border-bottom: 1px solid #edf0f2;
  border-top: 1px solid #edf0f2;
  text-align: left;
  letter-spacing: 1.6px;
  vertical-align: top;
  position: relative;
  width: 20%;
}
.formAdministration--table tbody td {
  color: #222222;
  font-size: 14px;
  padding: 15px 10px;
  line-height: 1.2;
  text-align: left;
  vertical-align: middle;
  width: 20%;
}
.formAdministration--table tbody tr:nth-child(odd) {
  background: #f8f9fa;
}
.formAdministration--pending,
.formAdministration--completed,
.formAdministration--failed {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.formAdministration--pending {
  background: #efc023;
}
.formAdministration--completed {
  background: #11b911;
}
.formAdministration--failed {
  background: #f00;
}
.formAdministration--table tbody td .formAdministration--actionIcon {
  margin-right: 10px;
  cursor: pointer;
}
.formAdministration--table tbody td.disable--actions {
  cursor: not-allowed;
}
.formAdministration--table
  tbody
  td.disable--actions
  .formAdministration--actionIcon,
.formAdministration--table
  tbody
  td.formAdministration--actions.disable--actions
  .formListingActions {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.formAdministration--table th.formAdministration--actions,
.formAdministration--table tbody td.formAdministration--actions {
  text-align: center;
  border-left: 2px solid #edf0f2;
}
.formAdministration--table tbody td.formAdministration--actions > div {
  display: flex;
  justify-content: center;
}
.formListingActions--btn {
  cursor: pointer;
}
.formListingActions {
  position: relative;
}
.formListingActions--content {
  position: absolute;
  right: 0;
  top: 40px;
  padding: 10px 0;
  background: #fff;
  box-shadow: 3px 3px 10px 6px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  width: 135px;
  text-align: left;
  z-index: 1;
}
.formListingActions--content .formListingActions--item {
  padding: 7px 10px 7px 12px;
  cursor: pointer;
  transition: all 0.4s;
  display: block;
  font-size: 12px;
}
.formListingActions--content .formListingActions--item:hover {
  background: #f8f9fa;
}
.formListingActions--content .formListingActions--item > a {
  color: #222;
}
.formAdministration--table tbody td.formAdministration--emptyList {
  font-weight: 700;
  padding: 20px;
  background: #fff;
  text-align: center;
}
.formAdministration__loaderWrapper {
  background: rgba(255, 255, 255, 0.5);
  min-height: 60px;
  position: fixed;
  top: 60px;
  left: 0;
  width: 100%;
  height: calc(100% - 60px);
  z-index: 1;
}
.formAdministration__loader,
.formAdministration__loader:before,
.formAdministration__loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: bblFadInOut 1.8s infinite ease-in-out;
}
.formAdministration__loader {
  color: #000;
  font-size: 7px;
  position: relative;
  text-indent: -9999em;
  animation-delay: -0.16s;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}
.formAdministration__loader:before,
.formAdministration__loader:after {
  content: '';
  position: absolute;
  top: 0;
}
.formAdministration__loader:before {
  left: -3.5em;
  animation-delay: -0.32s;
}
.formAdministration__loader:after {
  left: 3.5em;
}
.formAdministration--toastFail {
  background: #c91b1b;
}
.formAdministration--toastFail .toastmessage-faiIcon {
  display: inline;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  border: 1px solid #fff;
  font-size: 10px;
  color: #fff;
  text-align: center;
  padding-top: 1px;
}
.formAdministration--toastMessage.toastMessage {
  bottom: 150px;
  top: auto;
}
.sorting-wrapper {
  display: inline-block;
  position: relative;
  margin-left: 5px;
  height: 25px;
  width: 10px;
  top: -4px;
}
.sorting-dsc,
.sorting-asc {
  display: inline;
  height: 4px;
  width: 4px;
  background: transparent;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  position: absolute;
  left: 0;
}
.sorting-asc {
  border-bottom: 5px solid #989eac;
  top: 7px;
}
.sorting-dsc {
  border-top: 5px solid #989eac;
  top: 15px;
}
.sorting-asc.sortIcon--active {
  border-bottom: 5px solid #1984bc;
}
.sorting-dsc.sortIcon--active {
  border-top: 5px solid #1984bc;
}
.formAdministration--header {
  display: flex;
  align-items: top;
}
.formAdministration--columnLabel {
  display: inline-block;
  line-height: 1.5;
  height: 36px;
}

/* Additional styles for the filters */
.formAdministration--filters {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 60px;
  margin-top: 16px;
  float: right;
}

.formAdministration--filters input[type='text'],
.formAdministration--filters select {
  padding: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 250px;
}

.formAdministration--filters select {
  height: 120px;
}

/* Additional styles for multi-select dropdown */
select[multiple] {
  height: auto;
  overflow-y: auto;
}

.recordsPerPage {
  font-size: 14px;
  line-height: 19px;
  color: #505050;
}
.recordsPerPage--dropdown {
  margin-left: 10px;
  font-size: 14px;
  padding: 5px 10px;
  border-color: #505050;
  margin-right: 20px;
}
.recordsPerPage--dropdown:focus {
  outline: none;
}
.pagination--wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 25px;
}
.pagination--info {
  font-size: 14px;
  line-height: 19px;
  color: #505050;
}
.pagination {
  display: flex;
  justify-content: right;
}
.pagination--number .pagination--link {
  cursor: pointer;
  font-size: 14px;
  line-height: 19px;
  display: inline-block;
  padding: 8px 20px;
  border: 1px solid #edf0f2;
  border-radius: 4px;
  margin-right: 10px;
  background: #fff;
}
.pagination--prev .pagination--link,
.pagination--next .pagination--link {
  color: #0177b5;
  cursor: pointer;
  font-size: 14px;
  line-height: 19px;
  display: inline-block;
  padding: 8px 0px;
  margin-right: 10px;
}
.pagination--prev.disable .pagination--link,
.pagination--next.disable .pagination--link {
  opacity: 0.4;
  cursor: not-allowed;
}
.pagination--number.pagination--item__active .pagination--link {
  background: #119f58;
  color: #fff;
}
.pagination--infoWrapper {
  display: flex;
  align-items: center;
}
.searchInputWrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.inputSearch,
.clearSearchIcon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.inputSearch {
  right: 10px;
}

.clearSearchIcon {
  right: 6px;
}
.fcClearFilters,
.ioFilterSharp {
  cursor: pointer;
}

.filterButton {
  width: 137px;
  height: 43px;
  display: flex;
  align-items: center;
}

.buttonLabels {
  margin-left: 5px;
}

.carrierFilter--selected {
  color: #1984bc;
  cursor: pointer;
  padding: 5px 0;
  display: inline-block;
}
.carrierFilter--selectedInfo {
  position: relative;
  margin-left: 5px;
}
.carrierFilter--selectedValues {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  z-index: 1;
  top: 100%;
  left: 0;
  width: 250px;
  padding: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.carrierFilter--arrow {
  position: absolute;
  top: -11px;
  left: 10px;
  width: 0;
  height: 0;
  border-bottom: 10px solid #ccc;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
}

.formAdministration--table [id\$='-listbox'] {
  width: 250px;
  margin-left: -11px;
}
.overlay-label-value {
  display: inline-block;
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/carrierFormAdministration/carrierFormAdministration.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,UAAU;EACV,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;;;EAQE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;AACA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,qCAAqC;AACvC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;AACA;;EAEE,eAAe;EACf,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,gCAAgC;EAChC,QAAQ;AACV;AACA;EACE,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;AACA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB","sourcesContent":[".formAdministration--wrapper {\n  min-height: calc(100vh - 160px);\n  padding-top: 40px;\n}\n.formAdministration--wrapper .breadCrumb__wrapper {\n  padding: 0 40px 10px;\n}\n.formAdministration--content {\n  width: calc(100% - 80px);\n  margin: 10px auto 30px;\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid #edf0f2;\n  padding-left: 5px;\n}\n.formAdministration--heading {\n  font-size: 20px;\n  line-height: 1.4;\n  padding: 22px 25px;\n}\n.formAdministration--table {\n  width: 100%;\n}\n.formAdministration--table thead {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 1;\n  border-bottom: 1px solid #edf0f2;\n}\n.formAdministration--table th {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #989eac;\n  font-weight: 500;\n  padding: 18px 10px;\n  border-bottom: 1px solid #edf0f2;\n  border-top: 1px solid #edf0f2;\n  text-align: left;\n  letter-spacing: 1.6px;\n  vertical-align: top;\n  position: relative;\n  width: 20%;\n}\n.formAdministration--table tbody td {\n  color: #222222;\n  font-size: 14px;\n  padding: 15px 10px;\n  line-height: 1.2;\n  text-align: left;\n  vertical-align: middle;\n  width: 20%;\n}\n.formAdministration--table tbody tr:nth-child(odd) {\n  background: #f8f9fa;\n}\n.formAdministration--pending,\n.formAdministration--completed,\n.formAdministration--failed {\n  display: inline-block;\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  margin-right: 5px;\n}\n.formAdministration--pending {\n  background: #efc023;\n}\n.formAdministration--completed {\n  background: #11b911;\n}\n.formAdministration--failed {\n  background: #f00;\n}\n.formAdministration--table tbody td .formAdministration--actionIcon {\n  margin-right: 10px;\n  cursor: pointer;\n}\n.formAdministration--table tbody td.disable--actions {\n  cursor: not-allowed;\n}\n.formAdministration--table\n  tbody\n  td.disable--actions\n  .formAdministration--actionIcon,\n.formAdministration--table\n  tbody\n  td.formAdministration--actions.disable--actions\n  .formListingActions {\n  opacity: 0.6;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.formAdministration--table th.formAdministration--actions,\n.formAdministration--table tbody td.formAdministration--actions {\n  text-align: center;\n  border-left: 2px solid #edf0f2;\n}\n.formAdministration--table tbody td.formAdministration--actions > div {\n  display: flex;\n  justify-content: center;\n}\n.formListingActions--btn {\n  cursor: pointer;\n}\n.formListingActions {\n  position: relative;\n}\n.formListingActions--content {\n  position: absolute;\n  right: 0;\n  top: 40px;\n  padding: 10px 0;\n  background: #fff;\n  box-shadow: 3px 3px 10px 6px rgba(0, 0, 0, 0.06);\n  border-radius: 5px;\n  width: 135px;\n  text-align: left;\n  z-index: 1;\n}\n.formListingActions--content .formListingActions--item {\n  padding: 7px 10px 7px 12px;\n  cursor: pointer;\n  transition: all 0.4s;\n  display: block;\n  font-size: 12px;\n}\n.formListingActions--content .formListingActions--item:hover {\n  background: #f8f9fa;\n}\n.formListingActions--content .formListingActions--item > a {\n  color: #222;\n}\n.formAdministration--table tbody td.formAdministration--emptyList {\n  font-weight: 700;\n  padding: 20px;\n  background: #fff;\n  text-align: center;\n}\n.formAdministration__loaderWrapper {\n  background: rgba(255, 255, 255, 0.5);\n  min-height: 60px;\n  position: fixed;\n  top: 60px;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 60px);\n  z-index: 1;\n}\n.formAdministration__loader,\n.formAdministration__loader:before,\n.formAdministration__loader:after {\n  border-radius: 50%;\n  width: 2.5em;\n  height: 2.5em;\n  animation-fill-mode: both;\n  animation: bblFadInOut 1.8s infinite ease-in-out;\n}\n.formAdministration__loader {\n  color: #000;\n  font-size: 7px;\n  position: relative;\n  text-indent: -9999em;\n  animation-delay: -0.16s;\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n}\n.formAdministration__loader:before,\n.formAdministration__loader:after {\n  content: '';\n  position: absolute;\n  top: 0;\n}\n.formAdministration__loader:before {\n  left: -3.5em;\n  animation-delay: -0.32s;\n}\n.formAdministration__loader:after {\n  left: 3.5em;\n}\n.formAdministration--toastFail {\n  background: #c91b1b;\n}\n.formAdministration--toastFail .toastmessage-faiIcon {\n  display: inline;\n  height: 14px;\n  width: 14px;\n  border-radius: 50%;\n  border: 1px solid #fff;\n  font-size: 10px;\n  color: #fff;\n  text-align: center;\n  padding-top: 1px;\n}\n.formAdministration--toastMessage.toastMessage {\n  bottom: 150px;\n  top: auto;\n}\n.sorting-wrapper {\n  display: inline-block;\n  position: relative;\n  margin-left: 5px;\n  height: 25px;\n  width: 10px;\n  top: -4px;\n}\n.sorting-dsc,\n.sorting-asc {\n  display: inline;\n  height: 4px;\n  width: 4px;\n  background: transparent;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  position: absolute;\n  left: 0;\n}\n.sorting-asc {\n  border-bottom: 5px solid #989eac;\n  top: 7px;\n}\n.sorting-dsc {\n  border-top: 5px solid #989eac;\n  top: 15px;\n}\n.sorting-asc.sortIcon--active {\n  border-bottom: 5px solid #1984bc;\n}\n.sorting-dsc.sortIcon--active {\n  border-top: 5px solid #1984bc;\n}\n.formAdministration--header {\n  display: flex;\n  align-items: top;\n}\n.formAdministration--columnLabel {\n  display: inline-block;\n  line-height: 1.5;\n  height: 36px;\n}\n\n/* Additional styles for the filters */\n.formAdministration--filters {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-right: 60px;\n  margin-top: 16px;\n  float: right;\n}\n\n.formAdministration--filters input[type='text'],\n.formAdministration--filters select {\n  padding: 13px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  min-width: 250px;\n}\n\n.formAdministration--filters select {\n  height: 120px;\n}\n\n/* Additional styles for multi-select dropdown */\nselect[multiple] {\n  height: auto;\n  overflow-y: auto;\n}\n\n.recordsPerPage {\n  font-size: 14px;\n  line-height: 19px;\n  color: #505050;\n}\n.recordsPerPage--dropdown {\n  margin-left: 10px;\n  font-size: 14px;\n  padding: 5px 10px;\n  border-color: #505050;\n  margin-right: 20px;\n}\n.recordsPerPage--dropdown:focus {\n  outline: none;\n}\n.pagination--wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px 25px;\n}\n.pagination--info {\n  font-size: 14px;\n  line-height: 19px;\n  color: #505050;\n}\n.pagination {\n  display: flex;\n  justify-content: right;\n}\n.pagination--number .pagination--link {\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 19px;\n  display: inline-block;\n  padding: 8px 20px;\n  border: 1px solid #edf0f2;\n  border-radius: 4px;\n  margin-right: 10px;\n  background: #fff;\n}\n.pagination--prev .pagination--link,\n.pagination--next .pagination--link {\n  color: #0177b5;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 19px;\n  display: inline-block;\n  padding: 8px 0px;\n  margin-right: 10px;\n}\n.pagination--prev.disable .pagination--link,\n.pagination--next.disable .pagination--link {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.pagination--number.pagination--item__active .pagination--link {\n  background: #119f58;\n  color: #fff;\n}\n.pagination--infoWrapper {\n  display: flex;\n  align-items: center;\n}\n.searchInputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.inputSearch,\n.clearSearchIcon {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.inputSearch {\n  right: 10px;\n}\n\n.clearSearchIcon {\n  right: 6px;\n}\n.fcClearFilters,\n.ioFilterSharp {\n  cursor: pointer;\n}\n\n.filterButton {\n  width: 137px;\n  height: 43px;\n  display: flex;\n  align-items: center;\n}\n\n.buttonLabels {\n  margin-left: 5px;\n}\n\n.carrierFilter--selected {\n  color: #1984bc;\n  cursor: pointer;\n  padding: 5px 0;\n  display: inline-block;\n}\n.carrierFilter--selectedInfo {\n  position: relative;\n  margin-left: 5px;\n}\n.carrierFilter--selectedValues {\n  position: absolute;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  z-index: 1;\n  top: 100%;\n  left: 0;\n  width: 250px;\n  padding: 10px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n}\n.carrierFilter--arrow {\n  position: absolute;\n  top: -11px;\n  left: 10px;\n  width: 0;\n  height: 0;\n  border-bottom: 10px solid #ccc;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n}\n\n.formAdministration--table [id$='-listbox'] {\n  width: 250px;\n  margin-left: -11px;\n}\n.overlay-label-value {\n  display: inline-block;\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
